import { render, staticRenderFns } from "./PrecisionTeach.vue?vue&type=template&id=05144369&scoped=true"
import script from "./PrecisionTeach.vue?vue&type=script&lang=js"
export * from "./PrecisionTeach.vue?vue&type=script&lang=js"
import style0 from "./PrecisionTeach.vue?vue&type=style&index=0&id=05144369&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05144369",
  null
  
)

export default component.exports